const listeners = new Set()

export const onBackgroundReportCompleted = (listener) => {
  if (typeof listener !== 'function') return () => {}
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const emitBackgroundReportCompleted = async (payload) => {
  const pending = []

  listeners.forEach((listener) => {
    try {
      pending.push(Promise.resolve(listener(payload)))
    } catch (_) {
      // Evita romper el flujo global si un listener falla.
    }
  })

  await Promise.allSettled(pending)
}
